import Calendario from 'components/calendario/Calendario'
import AddCentro from 'components/centros/AddCentro'
import AddDepartamento from 'components/departamentos/AddDepartamento'
import ListadoFestivosImpl from 'components/festivos/ListadoFestivosImpl'
import AddHorario from 'components/horarios/AddHorario'
import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap'

function Asistente() {
  const [page, setPage] = useState(0);
  const components = [
    <AddCentro />,
    <AddDepartamento />,
    <AddHorario/>,
    <ListadoFestivosImpl/>
  ]
    const isLastPage = page === components.length - 1;
     const handleFinalizar = () => {
     navigate("/admin/index")
  };
  const navigate = useNavigate();
  const centroComponent = <AddCentro />
  return (
    <Card>
        <CardHeader>Asistente</CardHeader>
        <CardBody>
            {components[page]}
            <br/>
            <Row>
                <Col md="12" className='text-right'>

                    <Button color="secondary" onClick={() => setPage(page - 1)} disabled={page === 0}>anterior</Button>
                     {!isLastPage && (
                    <Button color="primary" onClick={() => setPage(page + 1)} disabled={page === components.length - 1}>siguiente</Button>
                     )}
                      {isLastPage && (
                     <Button
                    color="success"
                    onClick={handleFinalizar}
                   >
                finalizar
              </Button>
            )}

                </Col>
            </Row>
        </CardBody>
    </Card>
  )
}

export default Asistente
